import './EntryActionButtons.css';

import { useTranslate } from '../../../../../hooks/context/useTranslate';
import Button from '../../../../Button/Button';

export interface EntryActionButtonsProps {
  onCancel: () => void | Promise<void>;
  // Omit for cancel-only contents (list, card without manual entry).
  onConfirm?: () => void | Promise<void>;
  confirmDisabled?: boolean;
}

const EntryActionButtons = ({
  onCancel,
  onConfirm,
  confirmDisabled = false,
}: EntryActionButtonsProps) => {
  const { t } = useTranslate();

  return (
    <div className="entry-action-buttons">
      {onConfirm && (
        <Button
          color="primary"
          disabled={confirmDisabled}
          onClick={() => onConfirm()}
        >
          {t('control.modal.confirm')}
        </Button>
      )}
      <Button color="light" onClick={() => onCancel()}>
        {t('cancel')}
      </Button>
    </div>
  );
};

export default EntryActionButtons;
